module.exports = __webpack_public_path__ + "static/media/recovery-book5.3cf66a40.png";